import React from 'react';
import { IPlace } from '../../../models/interfaces/IPlace';

import StoryPlace from './StoryPlace';
import { StoryPlacesContainer } from './storyPlacesStyles';

type StoryPlacesProps = {
	places: IPlace[];
};

const StoryPlaces: React.FC<StoryPlacesProps> = ({ places }) => {
	return (
		<StoryPlacesContainer>
			{places.map((place, i) => (
				<StoryPlace key={place.id} place={place} ndx={i} />
			))}
		</StoryPlacesContainer>
	);
};

export default StoryPlaces;
